export default __webpack_public_path__ + "static/media/stock3_fhd.b482713a.jpg";